"use client"
import React, { useState, useEffect } from "react";

import useApi from "@/components/api/useApi";

export function CalendarDate({
  event,
  isSm,
  isCurrentMonth,
  isToday,
  dayNumber,
  onHover,
  onLeave,
  onClick
}) {
  const [backgroundImage, setBackgroundImage] = useState(null);

  const api = useApi();

  useEffect(() => {
    if (event.coverPhoto) {
      api.getImageBase64(event.coverPhoto).then(base64 => {
        setBackgroundImage(`url(${base64})`);
      });
    }
  }, [event.coverPhoto]);

  const handleMouseEnter = () => {
    if (!isSm && onHover) {
      onHover(event);
    }
  };

  const handleMouseLeave = () => {
    if (!isSm && onLeave) {
      onLeave();
    }
  };

  const handleClick = () => {
    if (isSm && onClick) {
      onClick(event);
    }
  };

  const isHighlighted = isToday && isCurrentMonth;
  const todayClass = isHighlighted ? "calendar-date-today" : "";

  if (event.coverPhoto && !isSm) {
    // Desktop: Background image with overlay
    return (
      <div
        className={`calendar-date-desktop ${todayClass}`.trim()}
        style={{
          backgroundImage: backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
      >
        <div className="calendar-date-desktop-overlay"></div>
        <div className="calendar-date-desktop-content">
          {isCurrentMonth && (
            <div className="calendar-date-day-number">{dayNumber}</div>
          )}
        </div>
      </div>
    );
  } else {
    // Text-only fallback or mobile
    const sizeClass = !isSm
      ? "calendar-date-text-desktop"
      : "calendar-date-text-mobile";
    const monthClass = isCurrentMonth
      ? "calendar-date-current-month"
      : "calendar-date-other-month";

    return (
      <div
        className={`calendar-date-text ${sizeClass} ${monthClass} ${todayClass}`.trim()}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
      >
        <div className="calendar-date-text-content">
          {isCurrentMonth && (
            <div className="calendar-date-text-day-number">{dayNumber}</div>
          )}
          {!isSm && (
            <div className="calendar-date-text-info">
              <div className="calendar-date-text-title">{event.title}</div>
              <div className="calendar-date-text-location">
                {event.location}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

// Empty calendar cell component
export function EmptyCalendarCell({
  dayNumber,
  isCurrentMonth,
  isToday,
  isSm,
  onHover
}) {
  const isHighlighted = isToday && isCurrentMonth;
  const todayClass = isHighlighted ? "calendar-date-today" : "";
  const sizeClass = !isSm
    ? "calendar-date-empty-desktop"
    : "calendar-date-empty-mobile";
  const monthClass = isCurrentMonth
    ? "calendar-date-empty-current-month"
    : "calendar-date-empty-other-month";

  return (
    <div
      className={`calendar-date-empty ${sizeClass} ${monthClass} ${todayClass}`.trim()}
      onMouseEnter={onHover}
    >
      <div className="calendar-date-empty-content">
        {isCurrentMonth && (
          <div
            className={`calendar-date-empty-day-number ${
              isCurrentMonth
                ? "calendar-date-empty-day-current-month"
                : "calendar-date-empty-day-other-month"
            }`}
          >
            {dayNumber}
          </div>
        )}
      </div>
    </div>
  );
}
